import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import { removeExistingSessionData } from "../lib/helper";
import {
  generateCodeChallenge,
  generateCodeVerifier,
  generateRandomState,
} from "../lib/helper";
import { Box, Button, Typography } from "@mui/material";

const Callback = () => {
  const [authUrl, setAuthUrl] = useState("");
  const [state, setState] = useState("");
  const [showLoginButton, setShowLoginButton] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const codeVerifier = localStorage.getItem("verifier");
  const ref = localStorage.getItem("ref");
  const hasRun = useRef(false);
  // useEffect(() => {
  //   getToken();
  // }, [codeVerifier]);

  useEffect(() => {
    if (!hasRun.current) {
      hasRun.current = true; // Mark as executed
      getToken();
    }
  }, [codeVerifier]); // Runs only once
  const getToken = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    const state = urlParams.get("state");

    if (code) {
      localStorage.setItem("code", code);
    }
    if (state) {
      localStorage.setItem("state", state);
    }
    if (ref === "login") {
      const requestBody = new URLSearchParams({
        client_id: process.env.REACT_APP_CLIENT_ID,
        grant_type: "authorization_code",
        code: code,
        redirect_uri: process.env.REACT_APP_REDIRECT_URI,
        code_verifier: codeVerifier,
      });

      axios
        .post(
          `https://fhir.epic.com/interconnect-fhir-oauth/oauth2/token`,
          requestBody,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then(async (response) => {
          if (response) {
            await getUserDetails(response?.data?.access_token);
            localStorage.setItem(
              "access_token",
              JSON.stringify(response?.data?.access_token)
            );
            localStorage.setItem("patient_id", response?.data?.patient);
            checkValidUser(response?.data?.access_token);
            {
              removeExistingSessionData();
              //  if(ref == 'qr'){
              //   navigate("/qr");
              //  }
              // else{
              //   navigate("/voice");
              // }
              navigate("/voice");
            }
          }
        })

        .catch((error) => {
          //             if(error?.status == 400){
          // setShowLoginButton(true)
          //             }
          //             else{
          console.error("Error fetching token:", error);
          // }
        });
    } else {
      navigate("/qr");
    }
  };

  const getUserDetails = async (token) => {
    if (!token) {
      console.error("Token is required.");
      return;
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_MELDRX_BASE_URL}connect/userinfo`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        localStorage.setItem("user_name", response?.data?.name);
        localStorage.setItem(
          "preferred_username",
          response?.data?.preferred_username
        );
      } else {
        console.error("Unexpected response:", response);
      }
    } catch (error) {
      console.error(
        "Error fetching user info:",
        error?.response?.data || error.message
      );
    }
  };

  const checkValidUser = async (token) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/patient?token=${token}`
      );
      if (response) {
        console.log("response", response);
      }
    } catch (error) {
      if (error.response) {
        console.error("Error Data:", error.response.data);

        if (error.response.status === 403) {
          navigate("/forbidden"); // Redirect to the forbidden page
        }
      }
    }
  };

  const scopes = process.env.REACT_APP_SPECIFIC_SCOPES;
  const scopeParam = scopes;
  const initAuthProcess = async () => {
    const verifier = generateCodeVerifier();
    const newState = generateRandomState();
    localStorage.setItem("verifier", verifier);
    localStorage.setItem("state", state);

    const launch = searchParams.get("launch");
    const challenge = await generateCodeChallenge(verifier);
    const params = new URLSearchParams({
      client_id: process.env.REACT_APP_CLIENT_ID,
      aud: process.env.REACT_APP_EPIC_FHIR_BASE_URL,
      redirect_uri: process.env.REACT_APP_REDIRECT_URI,
      scope: scopeParam,
      response_type: "code",
      code_challenge: challenge,
      state: newState,
      code_challenge_method: "S256",
    });

    if (launch) {
      params.append("launch", launch);
    }

    // const authLink = `${process.env.REACT_APP_MELDRX_BASE_URL}/connect/authorize?${params.toString()}`;
    const authLink = `${
      process.env.REACT_APP_EPIC_AUTH_URL
    }?${params.toString()}`;

    setAuthUrl(authLink);
    window.location.href = authLink; // Redirect after setting state
  };
  return (
    <>
      {/* {showLoginButton &&  */}
      <Box
        component={"div"}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          margin: "32px",
        }}
      >
        <Button
          variant="contained"
          onClick={initAuthProcess}
          sx={{
            backgroundColor: "#fff",
            color: "#000",
            borderRadius: "4px",
            padding: "8px",
            gap: "8px",
          }}
        >
          <Typography>Login</Typography>{" "}
        </Button>
      </Box>
      {/* } */}
    </>
  );
};

export default Callback;
